import "./styles.scss";

interface PaginacaoCustomProps {
  paginaAtual: number;
  totalDePaginas: number;
  onPageChange: (pagina: number) => void;
}

const Paginacao = ({
  paginaAtual,
  totalDePaginas,
  onPageChange,
}: PaginacaoCustomProps) => {
  function irPara(pagina: number) {
    if (pagina < 1 || pagina > totalDePaginas) return;
    onPageChange(pagina);
  }

  return (
    <div className="u-margem-superior-grande">
      <div className="paginacao-custom">
        <button
          className="botao-seta"
          onClick={() => irPara(1)}
          disabled={paginaAtual === 1}
        >
          {"|<"}
        </button>
        <button
          className="botao-seta"
          onClick={() => irPara(paginaAtual - 1)}
          disabled={paginaAtual === 1}
        >
          {"<"}
        </button>

        {(() => {
          const botoes = [];
          let start = Math.max(1, paginaAtual - 2);
          let end = Math.min(totalDePaginas, paginaAtual + 2);

          if (paginaAtual <= 3) {
            start = 1;
            end = Math.min(5, totalDePaginas);
          } else if (paginaAtual >= totalDePaginas - 2) {
            start = Math.max(totalDePaginas - 4, 1);
            end = totalDePaginas;
          }

          for (let p = start; p <= end; p++) {
            botoes.push(
              <button
                key={p}
                className={`botao-pagina ${p === paginaAtual ? "ativa" : ""}`}
                onClick={() => irPara(p)}
              >
                {p}
              </button>
            );
          }
          return botoes;
        })()}

        <button
          className="botao-seta"
          onClick={() => irPara(paginaAtual + 1)}
          disabled={paginaAtual === totalDePaginas}
        >
          {">"}
        </button>
        <button
          className="botao-seta"
          onClick={() => irPara(totalDePaginas)}
          disabled={paginaAtual === totalDePaginas}
        >
          {">|"}
        </button>
      </div>
    </div>
  );
};

export default Paginacao;
